export default function disasmIcons (images) {
  return { arrow: images.icons }
}
